// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3gHC6","label":"Completed_label__1EIBm"};